// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Tab, Tabs } from '@mui/material';
import Loading from '../../../components/Loading';
import { useParties } from '../../../contexts/PartiesContext';
import useComplianceService from '../../../hooks/queries/registry/onboarding/useComplianceService';
import useInstrumentSecurityControlService from '../../../hooks/queries/registry/onboarding/useInstrumentSecurityControlService';
import useRegistrarService from '../../../hooks/queries/registry/onboarding/useRegistrarService';
import { InstrumentConfigurations } from './InstrumentConfigurations';
import { OperatorConfigurations } from './OperatorConfigurations';

export const Configurations = () => {
  const { operator, party } = useParties();
  const registrarService = useRegistrarService();
  const complianceService = useComplianceService();
  const instrumentSecurityControlService = useInstrumentSecurityControlService();
  const isOperator = party === operator;
  const isRegistrar = !!registrarService.data;
  const isCompliance = !!complianceService.data;
  const isInstrumentSecurityControl =
    instrumentSecurityControlService.data?.payload.instrumentSecurityControl === party;
  const defaultTab = isOperator ? 0 : 1;
  const [value, setValue] = React.useState(defaultTab);
  const isLoading =
    registrarService.isLoading ||
    complianceService.isLoading ||
    instrumentSecurityControlService.isLoading;
  if (isLoading) return <Loading />;

  const onChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const configurations: { [key: number]: React.ReactNode } = {
    0: <OperatorConfigurations />,
    1: <InstrumentConfigurations />,
  };
  return (
    <>
      <Tabs variant="scrollable" value={value} onChange={onChange}>
        {isOperator && <Tab value={0} label="Operator Configurations" />}
        {(isOperator || isRegistrar || isCompliance || isInstrumentSecurityControl) && (
          <Tab value={1} label="Configured Tokens" />
        )}
      </Tabs>
      {configurations[value]}
    </>
  );
};
